import React from 'react';
import {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListBody,
  StructuredListRow,
  StructuredListCell,
  Tag,
} from '@carbon/react';
import Typography from '../../../components/Basics/Typography';
import Card from '../../../components/Basics/InfoCard.container';
import { red40 } from '@carbon/colors';

const GasolineraStructuredList = ({ title, subtitle, data = [], truckCount = 0 }) => {
  // Detect if the dataset contains extra columns
  const hasCargaDescarga =
    Array.isArray(data) &&
    data.some(item => 'lugar_carga' in item || 'lugar_descarga' in item);

  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%', // Full height to allow content spacing
      padding: '10px'
    }}>
      {/* Fixed Header */}
      <div style={{
        textAlign: 'center',
        flexShrink: 0, // Prevent shrinking
        padding: '10px 0',
      }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            justifyContent: 'space-between',
            width: '100%',
            overflow: 'hidden'
          }}
        >
          <Typography
            className="cds--type-heading-compact-01"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flexGrow: 1,
              minWidth: 0,
            }}
          >
            {title}
          </Typography>

          {truckCount >= 5 && (
            <Tag type="red" size="sm">
              Cola Activa
            </Tag>
          )}
        </div>
        {/* Subtitle */}
        {subtitle && (
          <Typography
            className="cds--type-heading-compact-01"
            style={{ marginBottom: '5px' }}
          >
            {subtitle}
          </Typography>
        )}
        {/* Truck Count */}
        <Typography
          className="cds--type-heading-compact-01"
          style={{
            color: truckCount >= 5 ? red40 : 'inherit',
          }}
        >
          {truckCount}
        </Typography>
      </div>

      {/* Scrollable Table */}
      <div
        style={{
          flexGrow: 1,
          overflowY: 'auto',
          marginTop: '10px',
        }}
      >
        <StructuredListWrapper isCondensed>
          <StructuredListHead>
            <StructuredListRow head>
              <StructuredListCell head>Patente</StructuredListCell>
              <StructuredListCell head>Nivel de Combustible</StructuredListCell>
              <StructuredListCell head>Minutos Permanencia</StructuredListCell>
              {hasCargaDescarga && <StructuredListCell head>Frente Asignado</StructuredListCell>}
            </StructuredListRow>
          </StructuredListHead>

          <StructuredListBody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <StructuredListRow key={index}>
                  <StructuredListCell>{item.patente}</StructuredListCell>
                  <StructuredListCell>
                    {item.nivel_combustible === -1
                      ? 'Nivel combustible no disponible'
                      : `${Math.round(item.nivel_combustible / 10)}%`}
                  </StructuredListCell>
                  <StructuredListCell>{Math.round(item.minutos_permanencia)}</StructuredListCell>
                  {hasCargaDescarga && (
                    <StructuredListCell>{item.lugar_descarga || '-'}</StructuredListCell>
                  )}
                </StructuredListRow>
              ))
            ) : (
              <StructuredListRow>
                <StructuredListCell>-</StructuredListCell>
                <StructuredListCell>-</StructuredListCell>
                <StructuredListCell>-</StructuredListCell>
                {hasCargaDescarga && <StructuredListCell>-</StructuredListCell>}
                {hasCargaDescarga && <StructuredListCell>-</StructuredListCell>}
              </StructuredListRow>
            )}
          </StructuredListBody>
        </StructuredListWrapper>
      </div>
    </div>
  );
};

export default GasolineraStructuredList;
